import { gql } from "@apollo/client"; // saveVisitaEvolucionPaciente.js


const SAVE_VISITA_EVOLUCION_PACIENTE = gql`
  mutation saveVisitaEvolucionPaciente($evolucion: String!, $idVisita: Int!) {
    saveVisitaEvolucionPaciente(evolucion: $evolucion, idVisita: $idVisita) {
      idVisita
    }
  }
`;

export default SAVE_VISITA_EVOLUCION_PACIENTE;

export const adaptSaveVisitaEvolucionPaciente = (data) => ({
  evolucion: !!data?.evolucion ? data?.evolucion : "",
  idVisita: data?.idVisita
});